import React from 'react';
import { observer } from 'mobx-react';
import './style/yInput.less';

interface InputProps {
  title: string;
  maxLength: number;
  onChange: (val: string) => void;
  render?: any;
  value?: string;
}

const YInput = observer((props: InputProps) => {
  const { title, value, maxLength, render = undefined, onChange } = props;

  return (
    <div className="securityStaff-input">
      <p>{title}</p>
      <input
        type='text'
        value={value || ''}
        autoComplete='off'
        onChange={(e)=> onChange(e.target.value)}
        maxLength={maxLength}
      />
      {render && (<div className="right">{render}</div>)}
    </div>
  )
})

export default YInput;
